import React from "react";
import { Col, Container, Image, Row, Stack } from "react-bootstrap";
import RecentNews from '../components/Recent-News'

const BlogDetailCotent = () => {
    return (
        <Container className="our-blog-post-detail">
            <Row>
                <Col md="8">
                    <Stack className="our-blog-post-left-column">
                        <Image src="/images/blog-post-1.jpg" />
                    </Stack>
                    <Stack className="blog-detail-content">
                        <p>
                            Mauris tellus sem, ultrices varius nisl at, convallis iaculis mauris. Sed eget sem vitae purus tempus dignissim. Quisque euismod nec lacus sit amet maximus. Ut convallis sagittis lorem auctor malesuada. Morbi auctor tortor eu risus condimentum.
                        </p>
                        <p>
                            Quisque bibendum mi quis consequat ultricies. Donec quis pharetra nisi, a congue justo. Aliquam erat volutpat. Nunc id lacus egestas, accumsan lorem eu, rhoncus velit. Duis dapibus varius mauris, ut rutrum leo vulputate a. Praesent ac fringilla turpis. Donec rhoncus eget enim sit amet euismod. Pellentesque pellentesque malesuada lobortis. Quisque et dictum nulla. Sed eu ante at massa imperdiet ultricies. Vivamus vulputate faucibus lorem, eget efficitur purus dictum nec.
                        </p>
                        <p>
                            Suspendisse condimentum, eros ac pulvinar iaculis, augue odio vehicula leo, vitae dictum nibh quam rhoncus risus. Nam tristique tellus et convallis faucibus. Cras in lacus at odio tristique tempor vel quis sem. Sed id lorem sit amet turpis mattis tempor.
                        </p>
                    </Stack>
                </Col>
                <RecentNews />
            </Row>
        </Container>
    )
}

export default BlogDetailCotent;